import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';

class AdminAgTable extends Component {
    constructor(props) {
        super(props);
        this.onGridReady = this.onGridReady.bind(this);
        this.createDatasource = this.createDatasource.bind(this);
        this.refresh = this.refresh.bind(this);
        this.gridApi = null;
        this.gridColumnApi = null;
        this._getRowsTimers = {};
        this._pendingGetRows = {};
    }

    onGridReady(params) {
        try {
            this.gridApi = params.api;
            this.gridColumnApi = params.columnApi;
            // set datasource
            if (typeof this.createDatasource === 'function') {
                try {
                    var comp = this;
                    setTimeout(function() { try { params.api.setDatasource(comp.createDatasource()); } catch(e){} }, 0);
                } catch (e) {}
            }
        } catch (e) {}
    }

    createDatasource() {
        var comp = this;
        var pageSize = this.props.pageSize || 100;
        return {
            getRows: function(getParams) {
                try {
                    if (!comp.props.onGetRows) return getParams.failCallback();
                    // Debounce/dedupe requests per block (startRow) to avoid rapid duplicate calls during fast scrolling
                    var key = '' + (
                        (typeof getParams.startRow === 'number')
                            ? getParams.startRow
                            : ((getParams.request && typeof getParams.request.startRow === 'number') ? getParams.request.startRow : 0)
                    );
                    // store the latest params for this startRow
                    comp._pendingGetRows[key] = getParams;
                    if (comp._getRowsTimers[key]) clearTimeout(comp._getRowsTimers[key]);
                    comp._getRowsTimers[key] = setTimeout(function() {
                        try {
                            var pending = comp._pendingGetRows[key];
                            if (!pending) return;
                            // call parent with full request payload (includes sortModel/filterModel)
                            var req = pending.request || {
                                startRow: pending.startRow,
                                endRow: pending.endRow,
                                sortModel: pending.sortModel,
                                filterModel: pending.filterModel
                            };
                            var p = Promise.resolve(comp.props.onGetRows(req));
                            p.then(function(result) {
                                if (!result) return pending.failCallback();
                                var rows = result.rows || [];
                                var total = (typeof result.total !== 'undefined') ? result.total : -1;
                                try { setTimeout(function() { try { pending.successCallback(rows, total); } catch(e) { try { pending.failCallback(); } catch(e){} } }, 0); } catch(e) { try { pending.failCallback(); } catch(e){} }
                            }).catch(function() { try { pending.failCallback(); } catch(e){} });
                        } catch (err) { try { getParams.failCallback(); } catch(e){} }
                        delete comp._pendingGetRows[key];
                        if (comp._getRowsTimers[key]) { clearTimeout(comp._getRowsTimers[key]); delete comp._getRowsTimers[key]; }
                    }, (typeof comp.props.getRowsDebounceMs === 'number') ? comp.props.getRowsDebounceMs : 50);
                } catch (err) { try { getParams.failCallback(); } catch(e){} }
            }
        };
    }

    refresh() {
        try {
            if (this.gridApi && typeof this.gridApi.purgeInfiniteCache === 'function') {
                try {
                    if (this._refreshTimer) clearTimeout(this._refreshTimer);
                    this._refreshTimer = setTimeout(function() { try { this.gridApi.purgeInfiniteCache(); } catch(e){} }.bind(this), 100);
                } catch(e) {}
            }
        } catch (e) {}
    }

    componentWillUnmount() {
        try { this.gridApi = null; this.gridColumnApi = null; } catch (e) {}
    }

    render() {
        var colDefs = this.props.columnDefs || [];
        var defaultColDef = this.props.defaultColDef || { sortable: true, filter: true, resizable: true };
        var themeClass = this.props.themeClass || 'ag-theme-bb-admin';
        var style = Object.assign({ height: this.props.height || '520px', width: '100%' }, this.props.style || {});

        return React.createElement('div', { className: themeClass, style: style },
            React.createElement(AgGridReact, {
                columnDefs: colDefs,
                defaultColDef: defaultColDef,
                frameworkComponents: this.props.frameworkComponents,
                components: this.props.components,
                context: this.props.context || {},
                domLayout: this.props.domLayout || 'normal',
                rowHeight: (typeof this.props.rowHeight !== 'undefined') ? this.props.rowHeight : 48,
                rowModelType: 'infinite',
                cacheBlockSize: this.props.pageSize || 100,
                maxBlocksInCache: (typeof this.props.maxBlocksInCache !== 'undefined') ? this.props.maxBlocksInCache : 5,
                infiniteInitialRowCount: (typeof this.props.infiniteInitialRowCount !== 'undefined') ? this.props.infiniteInitialRowCount : 1,
                onGridReady: this.onGridReady,
                onFirstDataRendered: this.props.onFirstDataRendered,
                getRowNodeId: this.props.getRowNodeId,
                rowClassRules: this.props.rowClassRules,
                getRowClass: this.props.getRowClass,
                onCellValueChanged: this.props.onCellValueChanged,
                onSelectionChanged: this.props.onSelectionChanged,
                onFilterChanged: this.props.onFilterChanged,
                onSortChanged: this.props.onSortChanged,
                onRowMouseEnter: this.props.onRowMouseEnter,
                onRowMouseLeave: this.props.onRowMouseLeave,
                singleClickEdit: !!this.props.singleClickEdit,
                stopEditingWhenCellsLoseFocus: this.props.stopEditingWhenCellsLoseFocus,
                suppressRowClickSelection: (typeof this.props.suppressRowClickSelection !== 'undefined') ? this.props.suppressRowClickSelection : true,
                rowSelection: this.props.rowSelection || 'multiple',
                suppressCellFocus: this.props.suppressCellFocus,
                animateRows: this.props.animateRows,
                suppressBrowserResizeObserver: true,
                suppressColumnVirtualisation: true,
                suppressPreventDefaultOnMouseWheel: true
            })
        );
    }
}

export default AdminAgTable;
